<template>
  <div class="min-h-screen bg-gradient-to-br from-green-50 to-green-100 darky">
    <div class="pattern-bg" aria-hidden="true"></div>

    <!-- Header -->
    <header class="bg-white shadow-md dark:bg-gray-800">
      <nav class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <!-- Logo and Brand -->
          <div class="flex items-center">
            <RouterLink :to="{ name: ROUTES.HOME }" class="flex items-center space-x-2">
              <img src="/logo.svg" alt="BoxBuddy" class="w-8 h-8">
              <span class="hidden text-xl font-bold text-gray-900 dark:text-white sm:block">BoxBuddy</span>
            </RouterLink>
          </div>

          <!-- Mobile Menu Button -->
          <div class="flex md:hidden">
            <button
              @click="mobileMenuOpen = !mobileMenuOpen"
              type="button"
              class="inline-flex justify-center items-center p-2 text-gray-400 rounded-md hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500"
              aria-controls="mobile-menu"
              :aria-expanded="mobileMenuOpen"
            >
              <span class="sr-only">Open main menu</span>
              <!-- Icon when menu is closed -->
              <svg
                :class="{'hidden': mobileMenuOpen, 'block': !mobileMenuOpen}"
                class="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <!-- Icon when menu is open -->
              <svg
                :class="{'block': mobileMenuOpen, 'hidden': !mobileMenuOpen}"
                class="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Desktop Navigation Links -->
          <div class="hidden md:flex md:items-center md:space-x-4">
            <template v-if="!user">
              <RouterLink :to="{ name: ROUTES.HOME }"
                class="px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                Home
              </RouterLink>
              <RouterLink :to="{ name: ROUTES.LOGIN }"
                class="px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                Login
              </RouterLink>
              <RouterLink :to="{ name: ROUTES.REGISTER }"
                class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600">
                Register
              </RouterLink>
            </template>
            <template v-else>
              <RouterLink :to="{ name: ROUTES.HOME }"
                class="px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                Home
              </RouterLink>
              <RouterLink :to="{ name: ROUTES.DASHBOARD }"
                class="px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100">
                Dashboard
              </RouterLink>
              <RouterLink :to="{ name: ROUTES.LOGOUT }"
                class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600">
                Logout
              </RouterLink>
            </template>
          </div>
        </div>
      </nav>

      <!-- Mobile menu, show/hide based on menu state -->
      <div
        id="mobile-menu"
        :class="{'block': mobileMenuOpen, 'hidden': !mobileMenuOpen}"
        class="md:hidden"
      >
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <template v-if="!user">
            <div class="flex flex-col items-start space-y-4">
            <RouterLink :to="{ name: ROUTES.HOME }"
              class="px-3 py-2 text-base font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700">
              Home
            </RouterLink>
            <RouterLink :to="{ name: ROUTES.LOGIN }"
              class="px-3 py-2 text-base font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700">
              Login
            </RouterLink>
            <RouterLink :to="{ name: ROUTES.REGISTER }"
              class="inline-flex px-3 py-2 text-base font-medium text-white bg-green-600 rounded-md hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600">
              Register
            </RouterLink>
            </div>
          </template>
          <template v-else>
            <div class="flex flex-col items-start space-y-4">
            <RouterLink :to="{ name: ROUTES.HOME }"
              class="px-3 py-2 text-base font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700">
              Home
            </RouterLink>
            <RouterLink :to="{ name: ROUTES.DASHBOARD }"
              class="px-3 py-2 text-base font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700">
              Dashboard
            </RouterLink>
            <RouterLink :to="{ name: ROUTES.LOGOUT }"
              class="px-3 py-2 text-base font-medium text-white bg-green-600 rounded-md hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600">
              Logout
            </RouterLink>
            </div>
          </template>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="py-6 sm:py-10">
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import { ROUTES } from '@/router/routeNames';
import { useAuthStore } from '@/stores/authStore';
import { storeToRefs } from 'pinia';
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute } from 'vue-router';
const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const mobileMenuOpen = ref(false);
const route = useRoute();

// Close mobile menu when route changes
watch(() => route.fullPath, () => {
  mobileMenuOpen.value = false;
});

// Close mobile menu when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuButton = document.querySelector('[aria-controls="mobile-menu"]');

  if (mobileMenuOpen.value && mobileMenu && !mobileMenu.contains(event.target as Node) &&
      mobileMenuButton && !mobileMenuButton.contains(event.target as Node)) {
    mobileMenuOpen.value = false;
  }
};

// Close mobile menu when pressing escape key
const handleEscKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && mobileMenuOpen.value) {
    mobileMenuOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('keydown', handleEscKey);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  document.removeEventListener('keydown', handleEscKey);
});
</script>

<style scoped>
.router-link-active {
  font-weight: 600;
}
</style>
